const Data = [
    {
        name: "Keerthi Reddy Samreddy",
        position: "SRC Head",
        imageUrl: "/assets/images/members/Heads21/Keerthi Reddy Samreddy.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Mridul Gupta",
        position: "SRC Head",
        imageUrl: "/assets/images/members/Heads21/Mridul Gupta.jpeg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {   
        name: "Vishal Kumar Mishra",
        position: "SRC Head",
        imageUrl: "/assets/images/members/Heads21/Vishal Kumar Mishra.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Biswashree Roy",
        position: "SRC Head",
        imageUrl: "/assets/images/members/Heads21/Biswashree Roy.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Ayushi Sharma",
        position: "SRC Head",
        imageUrl: "/images/profile.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    
]

export default Data;